export default function (d, mask) {
  if (!mask) mask = 'DD.MM.YYYY'
  d = new Date(d)
  let dd = d.getDate()
  dd = `${dd > 9 ? dd : `0${dd}`}`
  let mm = d.getMonth() + 1
  mm = `${mm > 9 ? mm : `0${mm}`}`
  const yyyy = `${d.getFullYear()}`
  return mask.replace('DD', dd).replace('MM', mm).replace('YYYY', yyyy)
}
